/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Loading_Questions_HintInputs */

const en_loading_questions_hint = /** @type {(inputs: Loading_Questions_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We are preparing questions based on your idea. Keep this page open.`)
};

const id_loading_questions_hint = /** @type {(inputs: Loading_Questions_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kami menyiapkan pertanyaan berdasarkan idemu. Biarkan halaman ini terbuka.`)
};

/**
* | output |
* | --- |
* | "We are preparing questions based on your idea. Keep this page open." |
*
* @param {Loading_Questions_HintInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const loading_questions_hint = /** @type {((inputs?: Loading_Questions_HintInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Loading_Questions_HintInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_loading_questions_hint(inputs)
	return en_loading_questions_hint(inputs)
});